export default "__VITE_ASSET__C4ENHl3V__"